import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: tokens.colorNeutralBackground1,
        overflowY: 'auto',
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    placeholder: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase400,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingLeft: '32px',
        paddingRight: '32px',
        paddingTop: '8px',
        paddingBottom: '8px',
        borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    },
    content: {
        paddingLeft: '32px',
        paddingRight: '32px',
        paddingTop: '24px',
        paddingBottom: '24px',
        maxWidth: '900px',
        lineHeight: tokens.lineHeightBase300,
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase300,
        '& h1': {
            fontSize: tokens.fontSizeHero800,
            fontWeight: tokens.fontWeightSemibold,
            marginTop: '0',
            marginBottom: '16px',
            color: tokens.colorNeutralForeground1,
            borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
            paddingBottom: '8px',
        },
        '& h2': {
            fontSize: tokens.fontSizeBase500,
            fontWeight: tokens.fontWeightSemibold,
            marginTop: '24px',
            marginBottom: '12px',
            color: tokens.colorNeutralForeground1,
        },
        '& h3': {
            fontSize: tokens.fontSizeBase400,
            fontWeight: tokens.fontWeightSemibold,
            marginTop: '20px',
            marginBottom: '8px',
            color: tokens.colorNeutralForeground1,
        },
        '& p': {
            marginTop: '0',
            marginBottom: '12px',
        },
        '& a': {
            color: tokens.colorBrandForegroundLink,
            textDecoration: 'none',
            ':hover': {
                textDecoration: 'underline',
            },
        },
        '& ul, & ol': {
            paddingLeft: '24px',
            marginTop: '0',
            marginBottom: '12px',
        },
        '& li': {
            marginBottom: '4px',
        },
        '& code': {
            backgroundColor: tokens.colorNeutralBackground3,
            paddingLeft: '4px',
            paddingRight: '4px',
            paddingTop: '2px',
            paddingBottom: '2px',
            borderRadius: tokens.borderRadiusMedium,
            fontFamily: tokens.fontFamilyMonospace,
            fontSize: tokens.fontSizeBase200,
        },
        '& pre': {
            backgroundColor: tokens.colorNeutralBackground3,
            padding: '16px',
            borderRadius: tokens.borderRadiusMedium,
            overflowX: 'auto',
            marginTop: '0',
            marginBottom: '12px',
            '& code': {
                backgroundColor: 'transparent',
                padding: '0',
            },
        },
        '& table': {
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '0',
            marginBottom: '16px',
            fontSize: tokens.fontSizeBase200,
        },
        '& th': {
            backgroundColor: tokens.colorNeutralBackground3,
            fontWeight: tokens.fontWeightSemibold,
            textAlign: 'left',
            padding: '8px',
            borderBottom: `2px solid ${tokens.colorNeutralStroke1}`,
        },
        '& td': {
            padding: '8px',
            borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
        },
        '& blockquote': {
            borderLeft: `3px solid ${tokens.colorBrandStroke1}`,
            marginLeft: '0',
            marginRight: '0',
            paddingLeft: '16px',
            color: tokens.colorNeutralForeground2,
        },
        '& hr': {
            border: 'none',
            borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
            marginTop: '24px',
            marginBottom: '24px',
        },
        '& strong': {
            fontWeight: tokens.fontWeightSemibold,
        },
    },
});
